import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import 'ckeditor5/ckeditor5.css';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    Alignment,
    BlockQuote,
    Bold,
    ClassicEditor,
    Code,
    Essentials,
    Font,
    Heading,
    Italic,
    Link,
    List,
    ListProperties,
    Paragraph,
    SourceEditing,
    Subscript,
    Superscript,
    Underline,
    Undo,
} from 'ckeditor5';

function CKEditorComponent({
   initialHtml,
   onChange,
}) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [editorInstance, setEditorInstance] = useState(null);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    const handleChange = () => {
        // Pull HTML from editor
        const updatedData = editorInstance.getData();
        onChange(updatedData);
    }

    if (!isLoaded) {
        return null;
    }

    return (
        <CKEditor
            editor={ ClassicEditor }
            config={ {
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        'fontSize',
                        'fontFamily',
                        'fontColor',
                        'fontBackgroundColor',
                        '|',
                        'alignment',
                        'bold',
                        'italic',
                        'link',
                        'underline',
                        'code',
                        '|',
                        'subscript',
                        'superscript',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'sourceEditing',
                    ],
                },
                plugins: [
                    Alignment,
                    BlockQuote,
                    Bold,
                    Code,
                    Essentials,
                    Font,
                    Heading,
                    Italic,
                    Link,
                    List,
                    ListProperties,
                    Paragraph,
                    SourceEditing,
                    Subscript,
                    Superscript,
                    Underline,
                    Undo,
                ],
                list: {
                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                },
                initialData: initialHtml,
            } }
            onChange={handleChange}
            onReady={ ( editor ) => {
                setEditorInstance(editor);
            } }
        />
    );
}


CKEditorComponent.propTypes = {
    onChange: PropTypes.func.isRequired,
    initialHtml: PropTypes.string,
}

export default CKEditorComponent;
